import { inject } from '@angular/core';
import { of } from 'rxjs';
import { Interceptor, isToolCompleteCommand, PromptResponse } from '@panaya/ai-chat/domain';
import { AiChatThinkingService } from './ai-chat-thinking.service';

export function createThinkingResponseInterceptor(): Interceptor<PromptResponse> {
    const service = inject(AiChatThinkingService);
    return (response: PromptResponse) => {
        response.commands.forEach((command) => {
            if (isToolCompleteCommand(command)) {
                service.notifyThinkingEvent({ state: 'completed', translationKey: 'aichat.thinking.answer_found' });
            } else if (command.type !== 'user_interact') {
                service.notifyThinkingEvent({ state: 'thinking', translationKey: 'aichat.thinking.in_progress' });
            }
        });
        return of(response);
    };
}
